import { PostgrestResponse } from '@supabase/supabase-js';
import { IVAdminRfid } from '../../../types/views/IVAdminRfid';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para administração de RFID
 * Corresponde à view 'vw_admin_rfid' no banco de dados
 */
export class ViewAdminRfid extends BaseMultiTenantService<IVAdminRfid> {
     constructor() {
          super('vw_admin_rfid', [], 'fk_id_organizacao');
     }

     /**
      * Lista pessoas com informações de RFID
      */
     async getPessoasComRfid(organizationId: number): Promise<PostgrestResponse<IVAdminRfid[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('nome');
     }

     /**
      * Pessoas com RFID ativo
      */
     async getPessoasRfidAtivo(organizationId: number): Promise<PostgrestResponse<IVAdminRfid[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('tem_rfid_ativo', true)
               .order('nome');
     }

     /**
      * Pessoas sem RFID
      */
     async getPessoasSemRfid(organizationId: number): Promise<PostgrestResponse<IVAdminRfid[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('tem_rfid_ativo', false)
               .order('nome');
     }

     /**
      * Pessoas por tipo com RFID
      */
     async getPessoasPorTipo(organizationId: number, tipoPessoa: string): Promise<PostgrestResponse<IVAdminRfid[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('tipo_pessoa', tipoPessoa)
               .order('nome');
     }

     /**
      * Busca pessoa por código RFID
      */
     async getPessoaPorCodigoRfid(organizationId: number, codigoRfid: string): Promise<PostgrestResponse<IVAdminRfid>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('codigo_rfid', codigoRfid)
               .eq('tem_rfid_ativo', true)
               .single();
     }

     /**
      * Estatísticas de RFID
      */
     async getEstatisticasRfid(organizationId: number): Promise<{
          total_pessoas: number;
          com_rfid_ativo: number;
          sem_rfid: number;
          percentual_com_rfid: number;
     }> {
          const [total, comRfid, semRfid] = await Promise.all([
               this.client
                    .from(this.tableName)
                    .select('pessoa_id', { count: 'exact' })
                    .eq(this.organizationIdField, organizationId),
               this.client
                    .from(this.tableName)
                    .select('pessoa_id', { count: 'exact' })
                    .eq(this.organizationIdField, organizationId)
                    .eq('tem_rfid_ativo', true),
               this.client
                    .from(this.tableName)
                    .select('pessoa_id', { count: 'exact' })
                    .eq(this.organizationIdField, organizationId)
                    .eq('tem_rfid_ativo', false)
          ]);

          return {
               total_pessoas: total.count || 0,
               com_rfid_ativo: comRfid.count || 0,
               sem_rfid: semRfid.count || 0,
               percentual_com_rfid: total.count ? ((comRfid.count || 0) / total.count * 100) : 0
          };
     }
}

export const viewAdminRfid = new ViewAdminRfid();
